<template>
    <div class="page-title-area bg-5">
        <div class="container">
            <div class="page-title-content">
                <h2>Appointment</h2>
                <ul>
                    <li>
                        <router-link to="/">
                            Home 
                        </router-link>
                    </li>
                    <li class="active">Appointment</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PageTitle'
}
</script>